/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import CollectionModule from 'client/store/modules/CollectionModule';
import ManageCommandTemplatesApi from 'client/api/v2/ManageCommandTemplatesApi';

export class CommandCustomTemplateCollectionClass extends CollectionModule {
  constructor(os = '', ...args) {
    super(...args);
    this.os = os.toLowerCase();
  }

  extractModule() {
    const module = super.extractModule();

    module.getters.getFilterBackUp = (...params) => this
      .getFilterBackUp(...params);

    module.actions.setProviderId = (...params) => this
      .setProviderId(...params);

    module.actions.setOrganizationId = (...params) => this
      .setOrganizationId(...params);

    return module;
  }

  // --------------------------------------------------------------------------
  // State
  // --------------------------------------------------------------------------
  getInitialState() {
    const state = super.getInitialState();

    // Adding if statement for allowing a cross-platform collection if none is specified
    if (this.os) {
      const filter = {
        name: 'commandType', operator: 'eq', value: this.os,
      };
      state.features.items.filters = [filter];
      state.features.items.filterBackUp = filter;
    }

    return state;
  }

  // --------------------------------------------------------------------------
  // Getters
  // --------------------------------------------------------------------------

  getFilterBackUp(state) {
    return state.features.items.filterBackUp;
  }
  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  /**
   * @description Set a providerId for this collection.
   */
  setProviderId(context, providerId) {
    this.Api.setProviderId(providerId);
  }

  /**
   * @description Set a organizationId for this collection.
   */
  setOrganizationId(context, organizationId) {
    this.Api.setOrganizationId(organizationId);
  }
}

export function createCommandCustomTemplateCollectionClass(os) {
  return new CommandCustomTemplateCollectionClass(os, ManageCommandTemplatesApi, 'id', 'name').extractModule();
}
